import {api_url, languages, levels, upload_path} from "../../_AE/Helpers";

export const CONTEXT = "plans";
export const API_URI = api_url+"/"+CONTEXT;
export const UPLOAD_PATH = upload_path+"/"+CONTEXT
export const SEARCHABLE = languages.map(l=>`name_${l}`).concat([]);
export const ROUTE_PREFIX = "/"+CONTEXT;
export const CONTEXT_TITLE = {
  singular: "Plan",
  plural: "Plan",
}
/**/


export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    // enabled: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "created_at",
  pageNumber: 1,
  pageSize: 10
};

export const defaultSetsEntity = {
  "weight": 0,
  "reps": 1,
  "priority": 0,
  "enabled": true
}

export const defaultSubSubEntity = {
  "exercise": undefined,
  "level": levels[0],
  "weight": 0,
  "reps": 1,
  "sets": 1,
  "rest": 0,
  "duration": 0,
  "priority": 0,
  "enabled": true,
  "plan_workout_exercise_sets":[defaultSetsEntity],
}

export const defaultSubEntity = {
  "name_fr": "",
  "name_en": "",
  "name_ar": "",
  "day": 1,
  "types":[],
  "muscles":[],
  "exercises":[defaultSubSubEntity],
  "enabled": true
}
export const defaultEntity = {
  "name_fr": "",
  "name_en": "",
  "name_ar": "",

  note_fr: "",
  note_en: "",
  note_ar: "",

  "level": "BEGINNER",
  "gender": "Both",
  "objective": "Build Muscle",

  "workouts":[defaultSubEntity],
  "enabled": true,
  "premium": false,


};


